import type { TextField } from '@payloadcms/plugin-form-builder/types';
import type { FC } from 'react';
import type { FieldErrorsImpl, FieldValues, UseFormRegister } from 'react-hook-form';

import { useTranslations } from 'next-intl';

import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { FormFieldError } from '@/payload/blocks/form/components/error';
import { cn } from '@/utils/cn';

type TextProps = TextField & {
  errors: Partial<FieldErrorsImpl<{ [x: string]: unknown }>>;
  register: UseFormRegister<FieldValues>;
};

export const Text: FC<TextProps> = ({ required: requiredFromProps, defaultValue, register, errors, label, name }) => {
  const t = useTranslations('forms');

  return (
    <div className="w-full space-y-2">
      <Label htmlFor={name}>{label}</Label>

      <Input
        aria-describedby={errors[name] ? `${name}-error` : undefined}
        aria-invalid={Boolean(errors[name])}
        autoComplete={
          name === 'first_name'
            ? 'given-name'
            : name === 'last_name'
              ? 'family-name'
              : name === 'phone'
                ? 'tel'
                : undefined
        }
        className={cn('min-h-12 w-full', errors[name] && 'border-red-300')}
        defaultValue={defaultValue}
        id={name}
        required={Boolean(requiredFromProps)}
        type="text"
        {...register(name, {
          minLength: {
            message: t('minLength2'),
            value: 2,
          },
          required: {
            message: t('required'),
            value: requiredFromProps || false,
          },
        })}
      />

      {errors[name] && (
        <FormFieldError id={`${name}-error`} message={String(errors[name]?.message || t('required'))} title={label} />
      )}
    </div>
  );
};
